import { BusinessObj } from "auth";
import { Mapper } from "lib/api";
import { UserPermissionDTO } from "models";

// first param is the DTO, second param is the class
export class BusinessObjMapper extends Mapper<UserPermissionDTO, BusinessObj> {
	constructor() {
		super(BusinessObj); // Pass the target class constructor
	}

	// Override only if you need custom mapping logic beyond plainToClass
	// protected override customMapping(source: SectorDTO, target: Sector): Sector {
	// 	return target
	// }
}

export function New(): BusinessObjMapper {
	return new BusinessObjMapper();
}
